/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import { UrbitBadge, ViennaBadge } from "src/components/UI/Icons";
import { Tooltip } from "src/components/UI/Tooltip";
interface Props {
  badges: string[];
}
export function Badges({ badges }: Props) {
  return (
    <>
      {(badges || []).map((badge: string, index: number) => {
        if (badge === "vht")
          return (
            <Tooltip tooltipText={"VIENNA"} delayShow={200} delayHide={0} key={`${badge}${index}`}>
              <ViennaBadge />
            </Tooltip>
          );
        if (badge === "urbit")
          return (
            <Tooltip tooltipText={"Urbit"} delayShow={200} delayHide={0} key={`${badge}${index}`}>
              <UrbitBadge />
            </Tooltip>
          );
        return <></>;
      })}
    </>
  );
}
